import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, React.ButtonHTMLAttributes<HTMLButtonElement> {
  href: string;
  variant: 'primary' | 'secondary';
  children: React.ReactNode;
  className: string;
  fullWidth: boolean;
}
export function Button({
  href,
  variant = 'primary',
  children,
  className = '',
  fullWidth,
  onClick,
  ...props
}: ButtonProps) {
  const widthStyles = fullWidth ? 'w-full' : '';
  if (variant === 'primary') {
    const cls = `btn-cta-sweep ${widthStyles} ${className}`;
    if (href) {
      return <>
          <a href={href} className={cls} onClick={onClick as any} data-id="element-397">
            <span className="btn-sweep-shine" data-id="element-398" />
            <span className="relative z-10" data-id="element-399">{children}</span>
          </a>
        </>;
    }
    return <>
        <button className={cls} onClick={onClick} {...props as any} data-id="element-400">
          <span className="btn-sweep-shine" data-id="element-401" />
          <span className="relative z-10" data-id="element-402">{children}</span>
        </button>
      </>;
  }
  // Secondary variant
  const secCls = `btn-secondary-sweep ${widthStyles} ${className}`;
  if (href) {
    return <>
        <a href={href} className={secCls} onClick={onClick as any} data-id="element-403">
          <span className="btn-sweep-shine-sec" data-id="element-404" />
          <span className="relative z-10" data-id="element-405">{children}</span>
        </a>
      </>;
  }
  return <>
      <button className={secCls} onClick={onClick} {...props as any} data-id="element-406">
        <span className="btn-sweep-shine-sec" data-id="element-407" />
        <span className="relative z-10" data-id="element-408">{children}</span>
      </button>
    </>;
}